import { render } from "./mpesa.vue?vue&type=template&id=6ceac0c6&scoped=true"
import script from "./mpesa.vue?vue&type=script&lang=js"
export * from "./mpesa.vue?vue&type=script&lang=js"

import "./mpesa.vue?vue&type=style&index=0&id=6ceac0c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceac0c6"]])

export default __exports__